/**
 * Call/dialog class
 */
import debug from 'debug'
const EARLY = Symbol('call is in early state')
const CONFIRMED = Symbol('call is answered')

const INCOMING = Symbol('incoming call')
const OUTGOING = Symbol('outgoing call')

const dbg = debug('store:class:call:')

export default class {
  constructor (data, incomingCall) {
    this.direction = incomingCall ? INCOMING : OUTGOING
    this.user = data.user
    this.name = data.name
    this.startTime = null
    this.setStartTime(data.starttime)
    this.callid = data.callid
    this.legClid = data.legClid
    this.state = data.state
    this.astchan = data.astchan
    this.srcAstchan = null
    this.amisrvid = data.amisrvid
    this.asthost = data.amihost
    // special setup for caller id name from
    // table dialogs on page reload
    if (data.from_cid || data.to_cid) {
      this.setDlgName(data.from_cid, data.to_cid)
    }
    this.bargein = null
  }

  /**
   * @public
   */
  setConfirmed () { this.state = CONFIRMED }
  setOutgoing () { this.direction = OUTGOING }
  setIncoming () { this.direction = INCOMING }
  setStartTime (utime) {
    const sec = parseInt(utime)
    const startTime = sec ? new Date(sec * 1000) : new Date()
    this.startTime = startTime.getTime() > Date.now()
      ? new Date()
      : startTime
  }

  /**
   * Update caller id (to user) name for confirmed call
   */
  setNames (data) {
    const [toName, toNum] = data?.touser?.split('|')
    if (toNum === this.user) {
      this.name = toName
    }
  }

  /**
   * Updat name member from dialogs vars
   */
  setDlgName (from, to) {
    if (!from && !to) {
      return
    }

    const matchName = (cid) => {
      const re = /^"?([^"]+)"? <([0-9]+)>/
      const m = cid?.match(re)
      if (!m) return false
      if (this.user === m[2]) {
        this.name = m[1]
        return true
      }
      return false
    }

    if (matchName(from)) {
      return
    }
    matchName(to)
  }

  /*
   * set call bargein data
   */
  setBargein (data) {
    if (data.event === 'ChanSpyStop') {
      this.bargein = null
      dbg('barge in call is gone')
      return
    }

    // add barge in data
    this.bargein = {
      mode: data.spyerchanvariable?.SPYMODE,
      spyerNum: data.spyercalleridnum,
      spyerName: data.spyercalleridname
    }
    dbg('barge in call with data: %o', this.bargein)
  }

  /**
   * @getters
   */
  get isEarly () { return this.state === EARLY }
  get isConfirmed () { return this.state === CONFIRMED }
  get isIncoming () { return this.direction === INCOMING }
  get isParked () { return this.parked === true }
  get isBargedin () { return !!this.bargein?.mode }
  get bargeinShow () { return !!this.bargein?.mode && (this.bargein.mode !== 'monitor') }
  get timesec () {
    return this.startTime
      ? Math.round((Date.now() - this.startTime) / 1000)
      : 0
  }

  /**
   * @static
   */

  /**
   * Init call from RMQ
   *
   * @param {Object} Data message from RMQ
   * @param {Boolean} Init for incoming call
   * @return void
   */
  static initiate (data, incomingCall) {
    const call = {}
    if (incomingCall) {
      call.user = this.fromuserExten(data.fromuser)
      call.name = this.fromuserName(data.fromuser)
    } else {
      call.user = data.touser
      call.name = data.touser
    }
    call.starttime = 0
    call.state = EARLY
    call.callid = data['call-id']
    call.legClid = data.legClid
    return new this(call, incomingCall)
  }

  /**
   * Init call from AMI event ParkedCall
   *
   * @param data Object AMI event ParkedCall
   * @return Call
   */
  static initParked (data) {
    const callData = {
      user: data.parkingspace,
      name: 'PARKING',
      starttime: 0,
      callid: data.parkeechanvariable?.SIPCALLID,
      legClid: '',
      state: CONFIRMED,
      parked: true
    }
    const call = new this(callData, false)
    call.parked = true
    return call
  }

  /**
   * Find call by extension number
   *
   * @param calls Array
   * @param exten
   * @return Call or null
   */
  static findByExten (calls, exten) {
    return calls.find((call) => call.user === exten) || null
  }

  static fromuserExten (fromuser) {
    const user = fromuser.split('|').map((el) => el.trim())
    return user[1] || user[0]
  }

  static fromuserName (fromuser) {
    const user = fromuser.split('|').map((el) => el.trim())
    return user[0]
  }

  static confirmedList (calls) {
    return calls.filter((c) => c.isConfirmed)
  }
}
